var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{staticClass:"order order-flight",attrs:{"data-step":"order"}},[_c('home-order-client-data')],1)}
var staticRenderFns = []

export { render, staticRenderFns }